import { ActionTypes } from '@services/auth'
import {
  FeedbackStatusEnum,
  useFeedbackStatusEnumText,
} from '@services/feedback'
import useFieldsError from '@shared/hooks/useFieldsError'
import { Form, Select } from '@shared/innmaxUI/Form'
import { TextArea } from '@shared/innmaxUI/Form/Input'
import moment from 'moment'
import { pathOr, values } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'src/components/Button'
import {
  TableColumn as Column,
  Field,
  FieldRequiredTip,
} from 'src/components/Form'
import { ModalBody, ModalFooter } from 'src/components/Modal'

type Props = {
  item: any
  isEdit: boolean
  isCreate?: boolean
  readOnly?: boolean
  onEdit: () => void
  onOk?: (val: any) => void
  onCancel?: (val: any) => void
  // onDeleteModalVisible?: (val?: any) => void
}

export default function BasicForm({
  item,
  isEdit,
  isCreate,
  readOnly,
  onEdit,
  onOk,
  onCancel,
  // onDeleteModalVisible,
  ...props
}: Props) {
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const { enumToText: statusEnumToText } = useFeedbackStatusEnumText()

  const renderError = useFieldsError({ isEdit, className: '' })

  //儲存
  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      const parmas = {
        ...item,
        ...values,
      }

      onOk && onOk(parmas)
    } catch (error) {
      console.error(error)
    }
  }

  React.useEffect(() => {
    form.setFieldsValue({
      ...item,
      expireAt: item?.expireAt ? moment(item.expireAt) : null,
    })
  }, [item, isEdit]) //eslint-disable-line

  const fieldProps = {
    item,
    isEdit,
  }

  return (
    <>
      <Form
        form={form}
        preserve={false}
        onValuesChange={(v, c) => {
          // console.log('[BasicForm]', v, c)
        }}>
        <input type="submit" style={{ display: 'none' }} />
        <ModalBody style={{ height: '75dvh' }}>
          {(isEdit || isCreate) && <FieldRequiredTip />}
          <Column
            {...fieldProps}
            isEdit={false}
            title={['表單號碼', '公司名稱']}
            field={['formNo', 'companyName']}
          />
          <Column
            {...fieldProps}
            isEdit={false}
            title={['姓名', 'email']}
            field={['name', 'email']}
          />

          <Column
            {...fieldProps}
            isEdit={false}
            title={['內文']}
            field={['content']}
          />
          <Column
            {...fieldProps}
            title={['狀態', '']}
            renderLeft={props => (
              <Field
                {...props}
                name={['status']}
                value={pathOr('', ['statusStr'], item)}
                initialValue={pathOr('', ['status'], item)}>
                <Select>
                  {values(FeedbackStatusEnum).map(status => (
                    <Select.Option key={status} value={status}>
                      {statusEnumToText(status)}
                    </Select.Option>
                  ))}
                </Select>
              </Field>
            )}
            renderRight={() => <></>}
          />
          <Column
            {...fieldProps}
            title={[t('camera:remark')]}
            renderLeft={props => (
              <Field
                {...props}
                name={['remark']}
                value={pathOr('', ['remark'], item)}
                initialValue={pathOr('', ['remark'], item)}>
                <TextArea />
              </Field>
            )}
          />
        </ModalBody>
        <div className="mt-20">{isEdit ? renderError : ''}</div>
      </Form>
      <ModalFooter>
        {readOnly ? (
          <>
            <span />
            {/* <Button.GotoEdit
              onClick={goEditPage}
              actionType={ActionTypes.UPDATABLE}
            /> */}
          </>
        ) : isCreate ? (
          <>
            <span />
            <span>
              <Button.Cancel onClick={onCancel} />
              <Button.Add
                className="ml-16"
                actionType={ActionTypes.CREATABLE}
                onClick={handleOk}
              />
            </span>
          </>
        ) : isEdit ? (
          <>
            <span />
            <div>
              <Button.Cancel onClick={onEdit} />
              <Button.Save onClick={handleOk} className="ml-16" />
            </div>
          </>
        ) : (
          <>
            <span />
            <Button.Edit onClick={onEdit} actionType={ActionTypes.UPDATABLE} />
          </>
        )}
      </ModalFooter>
    </>
  )
}
